import { FlexDiv, FlexRowDiv, CenteringDiv } from 'components/generic/HomePageComponents'
import { DirectoryWrapper, DirectoryLoadingSkeleton, SpaceAroundDiv } from './Styled'

const DirectoryLoadingScreen = () => (
  <DirectoryWrapper>
    <FlexRowDiv backgroundColor='white'>
      <CenteringDiv maxWidth='1259px' mb='48px' mr='16px' ml='16px' width='100%'>
        <SpaceAroundDiv flexDirection={{ _: 'column', tablet: 'row' }}>
          <DirectoryLoadingSkeleton
            mb='16px'
            mt='72px'
            minWidth={{ _: '250px', desktop: '260px' }}
            minHeight={{ _: '390px', tablet: '315px', desktop: '330px' }}
            mr='16px'
          />
          <FlexDiv flexDirection='column'>
            <DirectoryLoadingSkeleton maxWidth='450px' mt='20px' mb='24px' height='32px' />
            <DirectoryLoadingSkeleton
              mb='16px'
              minWidth={{ _: '335px', tablet: '115px', desktop: '845px' }}
              minHeight={{ _: '390px', tablet: '315px', desktop: '210px' }}
            />
            <DirectoryLoadingSkeleton
              mb='16px'
              minWidth={{ _: '335px', tablet: '115px', desktop: '845px' }}
              minHeight={{ _: '390px', tablet: '315px', desktop: '210px' }}
            />
            <DirectoryLoadingSkeleton
              mb='16px'
              minWidth={{ _: '335px', tablet: '115px', desktop: '845px' }}
              minHeight={{ _: '390px', tablet: '315px', desktop: '210px' }}
            />
            <DirectoryLoadingSkeleton
              minWidth={{ _: '335px', tablet: '360px', desktop: '945px' }}
              minHeight={{ _: '144px', tablet: '144px', desktop: '96px' }}
            />
            <DirectoryLoadingSkeleton
              mb='16px'
              minWidth={{ _: '335px', tablet: '115px', desktop: '845px' }}
              minHeight={{ _: '390px', tablet: '315px', desktop: '210px' }}
            />
            <DirectoryLoadingSkeleton
              mb='16px'
              minWidth={{ _: '335px', tablet: '115px', desktop: '845px' }}
              minHeight={{ _: '390px', tablet: '315px', desktop: '210px' }}
            />
          </FlexDiv>
        </SpaceAroundDiv>
      </CenteringDiv>
    </FlexRowDiv>
  </DirectoryWrapper>
)

export default DirectoryLoadingScreen
